<template>
  <section > 
    <b-row> 
      <b-col  class="box-effect linear" v-if="cargueCreated">
            <validation-observer v-slot="{ invalid } ">    
              <b-card> 
                  <template v-slot:header >       
                    <div class="header-card">
                      Crear Ficha del Afiliado
                    </div>                              
                  </template>                  
                  <b-form  inline style="margin-bottom:15px;" novalidate>                    
                    <div style="width:100%" class="p-2 mt-4">    
                      <b-nav tabs style="width:100%">
                        <b-nav-item :active="active===0" @click="updateDependiente()">Dependiente</b-nav-item>
                        <b-nav-item :active="active===1" @click="updateIndependiente()">Independiente</b-nav-item>
                      </b-nav>                   
                      <div v-show="active===0" style="border:1px solid; border-top:none;border-color: #dee2e6;width:100% ">
                        <b-row >                     
                          <b-col md="12">
                            <h5 class="title-form">Datos Personales</h5>                           
                            <b-row  class="row-inputs">  
                              <sw-inputs
                                  inputTabla="datos_afiliado"
                                  inputCampo="id_list_documento"
                                  :md="6"
                                  :lg="3"
                                >
                              </sw-inputs>  
                              <sw-inputs
                                  inputTabla="datos_afiliado"
                                  inputCampo="documento"
                                  :searchs="['id_list_estado','id_list_documento','documento','name']"
                                  list="datos_afiliado"
                                  :md="6"
                                  :lg="3"
                                >
                              </sw-inputs>     
                              <sw-inputs
                                  inputTabla="datos_afiliado"
                                  inputCampo="nacimiento"
                                  :md="6"
                                  :lg="6"
                                >
                              </sw-inputs>                   
                              <sw-inputs
                                  inputTabla="datos_afiliado"
                                  inputCampo="nombre1"
                                  :md="6"
                                  :lg="3"
                                >       
                              </sw-inputs>                            
                              <sw-inputs
                                  inputTabla="datos_afiliado"
                                  inputCampo="nombre2"
                                  :md="6"
                                  :lg="3"
                                >
                              </sw-inputs>                                    
                              <sw-inputs
                                  inputTabla="datos_afiliado"
                                  inputCampo="apellido1"
                                  :md="6"
                                  :lg="3"
                                >
                              </sw-inputs>                       
                              <sw-inputs
                                  inputTabla="datos_afiliado"
                                  inputCampo="apellido2"
                                  :md="6"
                                  :lg="3"
                                >
                              </sw-inputs>               
                              <sw-inputs
                                  inputTabla="datos_afiliado"
                                  inputCampo="email"
                                  :md="6"
                                  :lg="6"
                                >
                              </sw-inputs>                            
                              <sw-inputs
                                  inputTabla="datos_afiliado"
                                  inputCampo="direccion"
                                  :md="6"
                                  :lg="6"
                                >
                              </sw-inputs>                     
                              <sw-inputs
                                  inputTabla="datos_afiliado"
                                  inputCampo="ciudad"
                                  :md="3"
                                  :lg="3"
                                >
                              </sw-inputs>               
                              <sw-inputs
                                  inputTabla="datos_afiliado"
                                  inputCampo="telefonos"
                                  :md="3"
                                  :lg="3"
                                >
                              </sw-inputs>           
                              <sw-inputs
                                  inputTabla="datos_afiliado"
                                  inputCampo="referido"
                                  :md="3"
                                  :lg="3"
                                >
                              </sw-inputs>        
                              <sw-inputs
                                  v-if="dataForm[namePath].datos_afiliado.referido!==null"
                                  inputTabla="descuentos_referido"
                                  inputCampo="descuento"
                                  :md="3"
                                  :lg="3"
                                >
                              </sw-inputs>          
                              <sw-inputs
                                  style="margin-top: 15px"
                                  inputTabla="datos_afiliado"
                                  inputCampo="planilla"
                                  :md="3"
                                  :lg="3"
                                >
                              </sw-inputs>            
                            </b-row>
                          </b-col>   
                          <b-col md="12">
                            <h5 class="title-form">Datos afiliación</h5>
                            <b-row class="row-inputs">        
                                <sw-inputs
                                  inputTabla="info_afiliacion"
                                  inputCampo="ingreso"
                                  @input="changeAporte"
                                  :md="6"
                                  :lg="3"
                                  >
                                </sw-inputs>      
                                <sw-inputs
                                  inputTabla="info_afiliacion"
                                  inputCampo="mes_periodo"
                                  @input="changeAporte"
                                  :md="6"
                                  :lg="3"
                                  >
                                </sw-inputs>        
                                <sw-inputs
                                  inputTabla="info_afiliacion"
                                  inputCampo="ano_periodo"
                                  @input="changeAporte"
                                  :md="6"
                                  :lg="3"
                                  >
                                </sw-inputs>                                   
                                <sw-inputs
                                  inputTabla="info_afiliacion"
                                  inputCampo="id_list_novedad"
                                  :md="6"
                                  :lg="3"
                                  >
                                </sw-inputs>  
                                <sw-inputs
                                  inputTabla="info_afiliacion"
                                  inputCampo="dias"
                                  :md="6"
                                  :lg="3"
                                  >
                                </sw-inputs> 
                                 <sw-inputs
                                  inputTabla="info_afiliacion"
                                  inputCampo="id_datos_razon"
                                  :md="6"
                                  :lg="3"
                                  >
                                </sw-inputs>   
                                <sw-inputs
                                  inputTabla="info_afiliacion"
                                  inputCampo="salario"
                                  :md="6"
                                  :lg="3"
                                  >
                                </sw-inputs> 
                                <sw-inputs
                                  inputTabla="info_afiliacion"
                                  inputCampo="cargo"
                                  :md="6"
                                  :lg="3"
                                  >
                                </sw-inputs>  
                                <sw-inputs
                                  inputTabla="info_afiliacion"
                                  inputCampo="id_datos_asesor" 
                                  :md="6"
                                  :lg="3"  >
                                </sw-inputs>                           
                                <sw-inputs
                                  inputTabla="info_afiliacion"
                                  inputCampo="id_datos_contacto" 
                                  :md="6"
                                  :lg="3"  >
                                </sw-inputs>
                                <sw-inputs
                                  inputTabla="info_afiliacion"
                                  inputCampo="exonerado"
                                  :md="6"
                                  :lg="6"
                                  >
                                </sw-inputs> 
                                <sw-inputs
                                  inputTabla="info_afiliacion"
                                  inputCampo="id_list_tipo"
                                  :filter="{filter: active}"
                                  :md="12"
                                  :lg="6">
                                </sw-inputs>
                                <sw-inputs
                                  inputTabla="info_afiliacion"
                                  inputCampo="id_list_subtipo"
                                  :filter="{filter: dataForm[namePath].info_afiliacion.id_list_tipo}"
                                  :md="12"
                                  :lg="6">
                                </sw-inputs>
                            </b-row>
                          </b-col> 
                          <b-col  md="12" >
                            <h5 class="title-form">Servicios</h5>
                            <b-row>                              
                              <sw-tablemultiple
                                style="padding:0;"
                                class="tablemultiple-white"
                                getTable="multiple_servicios"
                                :views="[
                                  { th:'Select.', td: 'check'},
                                  { th:'Servicio', td: 'name'},
                                  { th:'Entidad', td: 'id_list'},
                                  { th:'Inicio L.', td: 'iniciolabores', style: 'width: 143px'},
                                  { th:'Afiliación', td: 'afiliacion'},
                                  { th:'Valor', td: 'valor'},
                                ]"
                                >
                              </sw-tablemultiple>
                                <sw-inputs
                                  inputTabla="info_afiliacion"
                                  inputCampo="observacion"
                                  :md="12"
                                  :lg="12"
                                  >
                                </sw-inputs> 
                            </b-row>
                          </b-col>
                           <b-col  md="12" class="mb-3">
                            <h5 class="title-form">Beneficiarios</h5>
                            <sw-tableform
                              :tableItems="beneficiariosItems"
                              tableTabla="afiliado_beneficiarios"
                              :tableCampos="['id','id_datos_afiliado','id_list_documento','name','documento','servicios','nacimiento']"
                              :inits="beneficiariosInits"
                              >                         
                            </sw-tableform>
                          </b-col>                                            
                        </b-row> 
                      </div>
                    </div>
                  </b-form>                 
                  <template v-if="active===0" v-slot:footer>
                    <b-row style="width:100%">
                      <b-col :md="12" :lg="12" v-if="errorsAportes!=='' && errorsAportes!==null">
                          <p  class="text-danger">* {{errorsAportes}}</p>  
                      </b-col>
                      <b-col>      
                        <sw-saveform
                        :invalid="invalidNovedad(invalid) || invalid"
                        limpiar                      
                        :index="dataIndex[namePath]"
                        nameBtn="Ficha del Afiliado"
                        @limpiar="limpiarForm"
                        @save="saveForm">
                        </sw-saveform> 
                      </b-col>
                    </b-row>         
                  </template>                                        
              </b-card>              
          </validation-observer>                   
      </b-col>      
    </b-row>
    <b-modal 
      v-model="openModal.modal.value"
      :title="openModal.modal.title" 
      :header-bg-variant="'primary'"
      header-text-variant="light"
      :hide-footer="true"  
      :no-close-on-backdrop="true" 
      size="lg"  
      >        
        <sw-modalafiliacion 
          v-if="openModal.modal.modal==='Afiliacion'"
          @save="saveForm"                     
          >
        </sw-modalafiliacion>  
        <sw-modalafiliaciongrupal 
          v-if="openModal.modal.modal==='AfiliacionGrupal'"
          @save="saveForm"                     
          >
        </sw-modalafiliaciongrupal>     
    </b-modal>
  </section>
</template>

<script>
import indexMix  from './indexMix.js'
import storeMix  from './storeMix.js'
import tableMix  from './tableMix.js'
import saveMix  from './saveMix.js'
import saveMixins  from '@/mixings/save.js'
import SwSaveform  from '@/components/forms/saveForm.vue'
import SwTablepost  from '@/components/dataTable/tablePost.vue'
import SwInputs  from '@/components/forms/inputs.vue'
import SwMinform  from '@/components/forms/minform.vue'
import SwTablemultiple  from '@/components/dataTable/tableMultiple.vue'
import SwModalafiliacion  from '@/components/modals/afiliacion.vue'
import SwModalafiliaciongrupal  from '@/components/modals/afiliacionGrupal.vue'
import { ValidationObserver } from 'vee-validate'
import SwSearchs from '@/components/forms/searchs.vue'
import SwLoading from '@/components/notification/loading.vue'
import SwTableget from '@/components/dataTable/tableGet.vue'
import SwTableform from '@/components/dataTable/tableForm.vue'

export default { 
  name: "afiliacion_nueva",
  mixins: [indexMix,storeMix,tableMix,saveMix,saveMixins,],
  components: {
    SwInputs,     
    SwTablepost,
    SwSaveform,
    ValidationObserver,
    SwTablemultiple,
    SwMinform,
    SwModalafiliacion,
    SwModalafiliaciongrupal,
    SwSearchs,
    SwLoading,
    SwTableget,
    SwTableform
  }
}
</script>
<style>
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link
{
  background: #fcfcfc;
  font-weight: 500;
}
.tablemultiple-white table 
{
  background: white;
}
</style>